// Mapa de herramientas y recursos de Finanzly con sus URLs y palabras clave
export interface ToolResource {
  id: string;
  name: string;
  url: string;
  keywords: string[];
  type: 'tool' | 'resource';
  icon?: string;
}

export const FINANZLY_TOOLS_RESOURCES: ToolResource[] = [
  // Herramientas (Calculadoras)
  {
    id: 'compound-interest',
    name: 'Calculadora de Interés Compuesto',
    url: '/tools/compound-interest',
    keywords: [
      'interés compuesto', 'compound interest', 'calculadora de interés', 
      'interest calculator', 'inversión a largo plazo', 'crecimiento de inversión',
      'interes compuesto', 'calcular interés', 'rendimiento de inversión'
    ],
    type: 'tool',
    icon: '📊'
  },
  {
    id: 'net-salary',
    name: 'Calculadora de Salario Neto',
    url: '/tools/net-salary',
    keywords: [
      'salario neto', 'net salary', 'calculadora de salario', 'salary calculator',
      'impuestos', 'taxes', 'deducciones', 'deductions', 'sueldo neto',
      'calcular salario', 'retenciones fiscales', 'salario después de impuestos'
    ],
    type: 'tool',
    icon: '💰'
  },
  {
    id: 'monthly-savings',
    name: 'Calculadora de Ahorro Mensual',
    url: '/tools/monthly-savings-calculator',
    keywords: [
      'ahorro mensual', 'monthly savings', 'calculadora de ahorro', 'savings calculator',
      'regla 50/30/20', '50 30 20 rule', 'presupuesto', 'budget', 'planificación financiera',
      'distribución de ingresos', 'income distribution', 'ahorro personal'
    ],
    type: 'tool',
    icon: '💸'
  },
  {
    id: 'mortgage',
    name: 'Calculadora de Hipoteca',
    url: '/tools/mortgage-calculator',
    keywords: [
      'hipoteca', 'mortgage', 'calculadora hipotecaria', 'mortgage calculator',
      'préstamo hipotecario', 'home loan', 'amortización', 'amortization',
      'pago mensual', 'monthly payment', 'intereses hipotecarios', 'comprar casa'
    ],
    type: 'tool',
    icon: '🏠'
  },
  
  // Recursos (Artículos)
  {
    id: 'compound-interest-article',
    name: 'El Poder del Interés Compuesto',
    url: '/resources/compound-interest-article',
    keywords: [
      'poder del interés compuesto', 'power of compound interest',
      'cómo funciona el interés compuesto', 'inversión exponencial',
      'crecimiento exponencial', 'efecto bola de nieve'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'retirement-planning-article',
    name: 'Planificación para la Jubilación',
    url: '/resources/retirement-planning-article',
    keywords: [
      'jubilación', 'retirement', 'planificación para el retiro', 'retirement planning',
      'ahorro para la jubilación', 'retirement savings', 'pensión', 'pension',
      'retiro financiero', 'planificar jubilación'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'emergency-fund',
    name: 'Fondo de Emergencia',
    url: '/resources/emergency-fund-article',
    keywords: [
      'fondo de emergencia', 'emergency fund', 'colchón financiero', 'financial cushion',
      'ahorro de emergencia', 'emergency savings', 'reserva financiera',
      'cómo crear un fondo de emergencia', 'fondo de contingencia'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'risk-return',
    name: 'Riesgo vs. Retorno',
    url: '/resources/risk-return-article',
    keywords: [
      'riesgo vs retorno', 'risk vs return', 'riesgo y rendimiento',
      'risk and return', 'análisis de riesgo', 'risk analysis',
      'relación riesgo retorno', 'tolerancia al riesgo', 'perfil de riesgo'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'investing-mistakes',
    name: 'Errores Comunes al Invertir',
    url: '/resources/investing-mistakes-article',
    keywords: [
      'errores al invertir', 'investing mistakes', 'errores comunes en inversión',
      'common investment mistakes', 'trampas de inversión', 'investment traps',
      'qué evitar al invertir', 'errores de inversores', 'evitar pérdidas'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'renting-vs-buying',
    name: 'Rentar vs. Comprar',
    url: '/resources/renting-vs-buying-article',
    keywords: [
      'rentar vs comprar', 'renting vs buying', 'alquilar o comprar',
      'rent or buy', 'comprar vivienda', 'buy home', 'alquilar casa',
      'rent house', 'decisión de vivienda', 'housing decision'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'inflation',
    name: 'Inflación y Tu Dinero',
    url: '/resources/inflation-article',
    keywords: [
      'inflación', 'inflation', 'poder adquisitivo', 'purchasing power',
      'proteger dinero de inflación', 'protect money from inflation',
      'efectos de la inflación', 'inflation effects', 'cómo combatir la inflación'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'cryptocurrency',
    name: 'Criptomonedas: Una Guía Básica',
    url: '/resources/crypto-article',
    keywords: [
      'criptomonedas', 'cryptocurrency', 'bitcoin', 'crypto', 'criptodivisas',
      'inversión en criptomonedas', 'crypto investment', 'blockchain',
      'guía de criptomonedas', 'crypto guide', 'invertir en bitcoin'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'monthly-savings-challenges',
    name: 'Retos de Ahorro Mensual',
    url: '/resources/monthly-saving-challenges-article',
    keywords: [
      'retos de ahorro', 'savings challenges', 'desafíos de ahorro',
      'saving challenges', 'challenge de ahorro', 'gamificación de ahorro',
      'reto 52 semanas', 'métodos de ahorro', 'estrategias de ahorro'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'impulse-buying',
    name: 'Compras Impulsivas',
    url: '/resources/impulse-buying-article',
    keywords: [
      'compras impulsivas', 'impulse buying', 'gastos innecesarios',
      'unnecessary expenses', 'control de gastos', 'expense control',
      'evitar compras impulsivas', 'cómo controlar gastos', 'gasto compulsivo'
    ],
    type: 'resource',
    icon: '📚'
  },
  {
    id: 'ai-investment',
    name: 'Inversión en Inteligencia Artificial',
    url: '/resources/ai-investment-article',
    keywords: [
      'inversión en ia', 'ai investment', 'acciones de inteligencia artificial',
      'artificial intelligence stocks', 'invertir en ia', 'investing in ai',
      'empresas de ia', 'ai companies', 'tecnología ia', 'ai technology',
      'acciones tecnológicas', 'tech stocks', 'semiconductores ia', 'machine learning',
      'inversión tecnológica', 'technology investment'
    ],
    type: 'resource',
    icon: '📚'
  }
];

/**
 * Detecta herramientas y recursos mencionados en el texto
 * @param text - El texto a analizar
 * @returns Array de herramientas/recursos detectados
 */
export function detectToolsAndResources(text: string): ToolResource[] {
  const lowerText = text.toLowerCase();
  const detected: ToolResource[] = [];
  const detectedIds = new Set<string>();

  for (const item of FINANZLY_TOOLS_RESOURCES) {
    // Evitar duplicados
    if (detectedIds.has(item.id)) continue;

    // Buscar coincidencias con las palabras clave
    const hasMatch = item.keywords.some(keyword => 
      lowerText.includes(keyword.toLowerCase())
    );

    if (hasMatch) {
      detected.push(item);
      detectedIds.add(item.id);
    }
  }

  return detected;
}

/**
 * Genera un mensaje sugerido para incluir en la respuesta del asistente
 * @param detectedItems - Array de herramientas/recursos detectados
 * @param language - Idioma para el mensaje ('es' o 'en')
 * @returns Mensaje de sugerencia o null si no hay items detectados
 */
export function generateSuggestionMessage(
  detectedItems: ToolResource[], 
  language: 'es' | 'en' = 'es'
): string | null {
  if (detectedItems.length === 0) return null;

  const messages = {
    es: {
      tool: '🛠️ Puedes usar nuestra',
      resource: '📚 Te recomiendo leer nuestro artículo sobre',
      multiple: '💡 Recursos relacionados que pueden ayudarte:'
    },
    en: {
      tool: '🛠️ You can use our',
      resource: '📚 I recommend reading our article about',
      multiple: '💡 Related resources that might help you:'
    }
  };

  if (detectedItems.length === 1) {
    const item = detectedItems[0];
    const prefix = item.type === 'tool' ? messages[language].tool : messages[language].resource;
    return `${prefix} "${item.name}"`;
  }

  return messages[language].multiple;
}
